import { render, staticRenderFns } from "./UpdateDayTrip.vue?vue&type=template&id=3d387140"
import script from "./UpdateDayTrip.vue?vue&type=script&lang=js"
export * from "./UpdateDayTrip.vue?vue&type=script&lang=js"
import style0 from "./UpdateDayTrip.vue?vue&type=style&index=0&id=3d387140&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports